import React from 'react';

interface UploadedFileCardProps {
  fileName: string;
  isPdf: boolean;
  isUploading: boolean;
  onDownload: () => void;
  onRemove: () => void;
}

const UploadedFileCard: React.FC<UploadedFileCardProps> = ({
  fileName,
  isPdf,
  isUploading,
  onDownload,
  onRemove,
}) => {
  return (
    <div className="border border-gray-200 rounded-lg p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-orange-100 p-3 rounded-lg">
            <svg className="w-8 h-8 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div>
            <p className="text-gray-900 font-medium">{fileName}</p>
            <p className="text-gray-500 text-sm">Manuscript uploaded successfully</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          {isPdf && (
            <button
              onClick={onDownload}
              disabled={isUploading}
              className="flex items-center gap-1 text-blue-500 hover:text-blue-600 text-sm disabled:opacity-50"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              <span>Download</span>
            </button>
          )}
          <button
            onClick={onRemove}
            disabled={isUploading}
            className="flex items-center gap-1 text-red-500 hover:text-red-600 text-sm disabled:opacity-50"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
            <span>Remove</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default UploadedFileCard;
